// Credit top-ups (one-time credit purchases on top of a subscription).
//
// Top-ups are labelled by AMOUNT, never by a marketing name: the old pack
// names (Starter/Standard/Pro/Studio) collided with the subscription tier
// names — a "Pro" pack sitting next to a "Pro" plan. Ids and Stripe price ids
// are unchanged; only the label is.
//
// MIRROR — display copy only, no purchase logic. Source of truth for ids,
// credit amounts, prices, and Stripe price ids:
//   packages/functions/billing/api/credit_packs.json

// "1,000" — grouped so a four-digit top-up doesn't read as "1000 credits".
export function formatCredits(credits) {
  const amount = Number(credits);
  return (Number.isFinite(amount) ? amount : 0).toLocaleString('en-US');
}

// "+1,000 credits" — the one place a top-up label is spelled.
export function topUpLabel(credits) {
  return `+${formatCredits(credits)} credits`;
}

// Static catalog for the marketing pricing page only. /pricing is a static
// page — it must render with no round-trip, so it does NOT call
// listCreditPacks(). Surfaces that transact (/credits) read the live catalog.
//
// Kept honest by topups.test.js, which reads credit_packs.json off disk and
// fails on any drift in ids, amounts, or prices — so a price change in billing
// cannot ship a /pricing page quoting the old number.
//
// BASE AMOUNTS ONLY: during a launch sale the callable serves doubled
// `launch_credits`, which this list does not model — /pricing would show base
// amounts while / and /credits show doubled ones. No sale is active, and
// topups.test.js fails if one is re-enabled without making this sale-aware.
export const TOP_UPS = [
  { id: 'starter', credits: 15, priceLabel: '$2.99' },
  { id: 'standard', credits: 60, priceLabel: '$9.99' },
  { id: 'pro', credits: 250, priceLabel: '$29.99' },
  { id: 'studio', credits: 1000, priceLabel: '$99.99' },
];
